/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Spec_Platforms_VInputs */

const en_home_spec_platforms_v = /** @type {(inputs: Home_Spec_Platforms_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows, macOS, Linux, FreeBSD, Web`)
};

/**
* | output |
* | --- |
* | "Windows, macOS, Linux, FreeBSD, Web" |
*
* @param {Home_Spec_Platforms_VInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_spec_platforms_v = /** @type {((inputs?: Home_Spec_Platforms_VInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Spec_Platforms_VInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_spec_platforms_v(inputs)
});
export { home_spec_platforms_v as "home.spec.platforms_v" }